module.exports = [{
      plugin: require('D:/projects/flash/node_modules/gatsby-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"]},
    },{
      plugin: require('D:/projects/flash/packages/gtf/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-145288300-1"},
    },{
      plugin: require('D:/projects/flash/packages/act-labs-blog/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
